// ── Country-parameterised region config ───────────────────────────────────────
// The fulfilment engine (postal validation, serviceability, currency) is written
// once and configured per country. India works today; the UK/US are config-only
// additions later. NOTE: operating in a new country still requires a locally
// licensed pharmacy, local prescriptions and a local pharmacist — this config is
// the software layer, not the legal one.

export const COUNTRIES = {
  IN: {
    name: 'India',
    currency: '₹',
    postal: {
      label: 'Pincode',
      // 6-digit PIN
      pattern: /^\d{6}$/,
      format: s => String(s || '').replace(/\D/g, '').slice(0, 6),
    },
    // Postal prefixes you actually deliver to. '*' = everywhere (pan-India via
    // courier). Restrict to real coverage as partner pharmacies onboard, e.g.
    // ['560', '110'] to serve only Bangalore + Delhi.
    serviceablePrefixes: ['*'],
  },
  GB: {
    name: 'United Kingdom',
    currency: '£',
    postal: {
      label: 'Postcode',
      // Alphanumeric UK postcode e.g. "SW1A 1AA"
      pattern: /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i,
      format: s => String(s || '').toUpperCase().slice(0, 8),
    },
    serviceablePrefixes: [],   // none until a UK pharmacy is onboarded
  },
  US: {
    name: 'United States',
    currency: '$',
    postal: {
      label: 'ZIP code',
      // 5-digit ZIP (optionally ZIP+4)
      pattern: /^\d{5}(-\d{4})?$/,
      format: s => String(s || '').replace(/[^\d-]/g, '').slice(0, 10),
    },
    serviceablePrefixes: [],
  },
}

export const DEFAULT_COUNTRY = 'IN'

export const getCountry = code => COUNTRIES[code] || COUNTRIES[DEFAULT_COUNTRY]

export function validatePostal(country, postal) {
  const c = getCountry(country)
  return c.postal.pattern.test(String(postal || '').trim())
}

// Is this delivery location inside our fulfilment coverage?
export function isServiceable(country, postal) {
  const c = getCountry(country)
  const p = String(postal || '').trim()
  if (!c.postal.pattern.test(p)) return false          // must be a valid postal code first
  const pfx = c.serviceablePrefixes
  if (!pfx.length) return false                         // no coverage configured yet
  if (pfx.includes('*')) return true                    // everywhere
  return pfx.some(x => p.replace(/\s/g, '').toUpperCase().startsWith(String(x).toUpperCase()))
}
